import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs';

@Component({
    selector: 'gd-address',
    styleUrls: ['./globalform.css'],
    template: `
    <div [formGroup]="form">
      <div class="surroundingdiv">
        <div>
          Address1 :
          <input
            class="gwidth"
            kendoTextBox
            id="address1addr"
            formControlName="address1addr"
            name="address1addr"
          />
        </div>
        <div class="gpadd">
          Address2 :
          <input
            class="gwidth"
            kendoTextBox
            id="address2addr"
            formControlName="address2addr"
            name="address2addr"
          />
        </div>
        <div class="gpadd">
          City :
          <input
            class="gwidth"
            kendoTextBox
            id="cityaddr"
            formControlName="cityaddr"
            name="cityaddr"
          />
        </div>
        <div class="gpadd">
          State :
          <kendo-dropdownlist
            #state
            name="stateaddr"
            [virtual]="virtual"
            formControlName="stateaddr"
            [data]="listStates"
            [valuePrimitive]="true"
            [textField]="'stateValue'"
            [valueField]="'stateId'"
            style="width:100px"
          >
          </kendo-dropdownlist>
        </div>
        <div class="gpadd">
          Zip Code :
          <input
            class="gwidth"
            kendoTextBox
            id="zipcodeaddr"
            formControlName="zipcodeaddr"
            name="zipcodeaddr"
          />
        </div>

        <div
          class="gtext"
          *ngIf="field.value !== 'true' || field.value === null"
        >
          * Please verify the address before making changes.
        </div>
      </div>
      <div
        class="gcheck"
        *ngIf="field.value !== 'true' || field.value === null"
      >
       <!--  <input
          type="checkbox"
          kendoCheckBox
          id="addressvalidated"
          name="addressvalidated"
          formControlName="addressvalidated"
        />
       Address Validated <span style="color:red">*</span> -->
      </div>
    </div>
  `,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        KENDO_INPUTS,
        KENDO_DROPDOWNS,
        NgIf,
    ]
})
export class AddressFormFieldsComponent {
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  get isValid() {
    return this.form.controls[this.field.name].valid
  }
  get isDirty() {
    return this.form.controls[this.field.name].dirty
  }

  public virtual: any = {
    itemHeight: 20,
  }
  public listStates: Array<any> = [
    { stateValue: 'AK', stateId: 1 },
    { stateValue: 'AL', stateId: 2 },
    { stateValue: 'AR', stateId: 3 },
    { stateValue: 'AS', stateId: 53 },
    { stateValue: 'AZ', stateId: 4 },
    { stateValue: 'CA', stateId: 5 },
    { stateValue: 'CO', stateId: 6 },
    { stateValue: 'CT', stateId: 7 },
    { stateValue: 'DC', stateId: 8 },
    { stateValue: 'DE', stateId: 9 },
    { stateValue: 'FL', stateId: 10 },
    { stateValue: 'GA', stateId: 11 },
    { stateValue: 'HI', stateId: 12 },
    { stateValue: 'IA', stateId: 13 },
    { stateValue: 'ID', stateId: 14 },
    { stateValue: 'IL', stateId: 15 },
    { stateValue: 'IN', stateId: 16 },
    { stateValue: 'KS', stateId: 17 },
    { stateValue: 'KY', stateId: 18 },
    { stateValue: 'LA', stateId: 19 },
    { stateValue: 'MA', stateId: 20 },
    { stateValue: 'MD', stateId: 21 },
    { stateValue: 'ME', stateId: 22 },
    { stateValue: 'MI', stateId: 23 },
    { stateValue: 'MN', stateId: 24 },
    { stateValue: 'MO', stateId: 25 },
    { stateValue: 'MS', stateId: 26 },
    { stateValue: 'MT', stateId: 27 },
    { stateValue: 'NC', stateId: 28 },
    { stateValue: 'ND', stateId: 29 },
    { stateValue: 'NE', stateId: 30 },
    { stateValue: 'NH', stateId: 31 },
    { stateValue: 'NJ', stateId: 32 },
    { stateValue: 'NM', stateId: 33 },
    { stateValue: 'NV', stateId: 34 },
    { stateValue: 'NY', stateId: 35 },
    { stateValue: 'OH', stateId: 36 },
    { stateValue: 'OK', stateId: 37 },
    { stateValue: 'OR', stateId: 38 },
    { stateValue: 'PA', stateId: 39 },
    { stateValue: 'PR', stateId: 40 },
    { stateValue: 'RI', stateId: 41 },
    { stateValue: 'SC', stateId: 42 },
    { stateValue: 'SD', stateId: 43 },
    { stateValue: 'TN', stateId: 44 },
    { stateValue: 'TX', stateId: 45 },
    { stateValue: 'UT', stateId: 46 },
    { stateValue: 'VA', stateId: 47 },
    { stateValue: 'VT', stateId: 48 },
    { stateValue: 'WA', stateId: 49 },
    { stateValue: 'WI', stateId: 50 },
    { stateValue: 'WV', stateId: 51 },
    { stateValue: 'WY', stateId: 52 },
  ]
  constructor() {
    // alert()
    /*     this.form.get('address1addr').setValue('test');
    this.form.value.address1addr = "test"; */
  }
}
